module.exports = __webpack_public_path__ + "img/oxford-logo.c363c973.png";